import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ArtistSuggestion, CreateArtistSuggestion } from '../models/artist-suggestion.model';

@Injectable({
  providedIn: 'root',
})
export class ArtistSuggestionService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/artist-suggestions`;

  create(suggestion: CreateArtistSuggestion): Observable<ArtistSuggestion> {
    return this.http
      .post<{ status: string; data: { suggestion: ArtistSuggestion } }>(this.apiUrl, suggestion)
      .pipe(map((response) => response.data.suggestion));
  }

  getAllAdmin(status?: 'pending' | 'approved' | 'rejected'): Observable<ArtistSuggestion[]> {
    const url = status ? `${this.apiUrl}/admin?status=${status}` : `${this.apiUrl}/admin`;
    return this.http
      .get<{ status: string; data: { suggestions: ArtistSuggestion[] } }>(url)
      .pipe(map((response) => response.data.suggestions));
  }

  updateStatus(id: number, status: 'approved' | 'rejected'): Observable<ArtistSuggestion> {
    return this.http
      .patch<{ status: string; data: { suggestion: ArtistSuggestion } }>(
        `${this.apiUrl}/admin/${id}/status`,
        { status }
      )
      .pipe(map((response) => response.data.suggestion));
  }

  delete(id: number): Observable<void> {
    return this.http
      .delete<{ status: string; message: string }>(`${this.apiUrl}/admin/${id}`)
      .pipe(map(() => undefined));
  }
}
